import React from 'react';
import * as types from '../../actions/actionTypes';
import CollapsableContainer from '../common/CollapsableContainer';
import Text from '../common/Text';
import CloudFrontPicture from '../image/CloudFrontPicture';
import InternalLink from '../InternalLink';
import CurentWinner from './CurrentHashtagWinner';
import History from './HashtagWinnerHistory';

const Hashtag = () => (
    <React.Fragment>
        <Text>
            <Text.Heading
                text='Hashtag Jul/Aug/Sep - #herbstschnoffle'
                level={3}
            />
            <p>
                <span
                    className='schnoffle-bold'>#herbstschnoffle&nbsp;</span> Nichts
                ist so golden wie der Herbst? Wenn die Blätter bunt über die
                Straße wehen, dann dürfen die gedruckten Stoffe sich einreihen.
                Komm gern stöbern und entdecke jede Menge Farbe und näh Dir
                Designerstücke für den kommenden Herbst. Zeig uns Deine
                Modeskizze in den sozialen Medien mit dem Hashtag #schnoffle
                #herbstschnoffle
            </p>

            <InternalLink
                to={{
                    type: types.NAVIGATED_TO_SINGLE_PATTERN_VIEW,
                    payload: {
                        sewpatId: 'pony',
                        patternid: 17986,
                    },
                    // meta: { query: { colors: '000000,b44a3f,eccdc4' } },
                }}
            >
                <CloudFrontPicture
                    src='hashtag-herbstschnoffle.jpg'
                    webp='hashtag-herbstschnoffle.webp' schnoffle
                />
            </InternalLink>
            <Text.Divider/>
            <CurentWinner/>
            <Text.Divider/>
            <Text.Heading text='Idee' level={2} png/>
            <p>
                Quartalsweise suchen wir zu einem Thema das schönste
                Designerstück.
                Dafür gibt es immer eine kurze Geschichte zur Thematik und die
                entsprechende Jury (erstmal Ellen & Dagmar, später vielleicht
                auch
                Blogger), die den schönsten Entwurf aussuchen wird.
            </p>
            <Text.Heading text='Wann?' level={5}/>
            <p>
                Immer das erste Wochenende im neuen Quartal wird der Siegbeitrag
                des vorherigen Quartals gekürt!
                Also im Oktober das Quartalsthema Juli/Aug/Sept usw.
            </p>
            <Text.Heading text='Wie?' level={5}/>
            <p>
                Jeder gestaltet seinen Lieblingsschnitt im passenden Stoff zum
                Thema und pinnt diesen mit einem spezifischen #Hashtag bei
                Pinterest,
                teilt die Modezeichnung unter Angabe von Schnitt + Stoffdesign
                bei Instagram oder Facebook.
            </p>
            <Text.Heading text='Was?' level={5}/>
            <p>
                Unter allen, die unter dem Hashtag mitmachen, kürt die Jury den
                Gewinner.
            </p>
            <Text.Divider/>
            <Text.Heading text='Themen' level={4}/>
            <ul>
                <li>
                    Im April/Mai/Juni - Springflower <span
                    className='schnoffle-bold'
                >#springschnoffle</span>
                </li>
                <li>
                    Im Juli/August/September - Bunter Herbst<span
                    className='schnoffle-bold'
                >#herbstschnoffle</span>
                </li>
                <li>
                    to be continued...
                </li>
            </ul>
            <Text.Divider/>
            <CollapsableContainer
                heading='Hilfe zum Pinnen/Teilen der Modeskizzen'
            >
                <p>Pinterest: <a
                    href='https://about.pinterest.com/de/browser-button'
                >Mit dem
                    "Pin it" Button geht es mit dem Teilen der
                    eigenen Entwürfe auf jedem Gerät super leicht...</a></p>

                <p>Modezeichnung einfach per Handy teilen:
                    Einfach das Foto vom Entwurf gedrückt halten bis die
                    Aufforderung zum "Bild teilen" kommt. Dann auf Facebook,
                    Instagram und/oder Pinterest mit dem Hashtag des Monats so
                    veröffentlichen, dass der Post allen zugänglich ist.</p>
                <CloudFrontPicture
                    src='schnoffle-teilen.gif' gif='schnoffle-teilen.gif'
                    webp='schnoffle-teilen.webp' schnoffle
                />
            </CollapsableContainer>
            <CollapsableContainer
                heading='Teilnahmebedingungen'
            >

                <Text.Heading
                    text='Wer veranstaltet das Gewinnspiel?'
                    level={6}
                />
                <p>Becker & Karsten UG (haftungsbeschränkt),Sandhauser Straße
                    107, 13505 Berlin</p>

                <Text.Heading text='Wer nimmt teil?' level={6}/>
                <p>Jede, die einen Entwurf zum jeweiligen Quartalsthema unter
                    dem jeweiligen Hashtag auf den sozialen Netzwerken Pinterest
                    und Facebook oder Instagram beiträgt.</p>
                <Text.Heading
                    text='Wann findet das Gewinnspiel statt?'
                    level={6}
                />
                <p>Das Gewinnspiel findet jedes Quartal statt.</p>

                <Text.Heading text='Was kann ich gewinnen?' level={6}/>
                <p>Es kann ein Nähpaket aus Schnitt + selbst gestaltetem
                    Stoff gewonnen werden.</p>

                <Text.Heading
                    text='Wann und wie wird die Gewinnerin bestimmt?'
                    level={6}
                />
                <p>Immer am ersten Sonntag im Quartal wird der Gewinnerbeitrag
                    des vorherigen Quartals durch eine Jury bestimmt.</p>

                <Text.Heading
                    text='Wie bekomme ich den Gewinn?'
                    level={6}
                />
                <p>Wir veröffentlichen die Sieger-Modeskizze und einen
                    Link zu dem entsprechenden Post. Wir produzieren den Stoff
                    für das Nähpaket nachdem die
                    Gewinnerin durch die Jury gewählt wurde und uns die
                    entsprechenden
                    Daten (Name und Anschrift) mitgeteilt hat. Das Nähpaket wird
                    dann nach etwa 3 Wochen an die Gewinnerin versendet.
                </p>
                <Text.Heading
                    text='Datenschutz'
                    level={6}
                />
                <p>Wir veröffentlichen auf https://www.schnoffle.de/hashtag und
                    in den Sozialen Medien die Modeskizze, die
                    gewonnen hat und verlinken den Gewinnerbeitrag in den
                    jeweiligen Sozialen Netzwerken.
                </p>
                <p>Näheres zum Datenschutz bei uns,
                    <InternalLink
                        className='stolo-footer-link'
                        to={{ type: types.NAVIGATED_TO_PRIVACY }}
                    >
                        &nbsp;findest Du hier.
                    </InternalLink>
                </p>
            </CollapsableContainer>
            <CollapsableContainer
                heading='Datenschutz'
            >

                <Text.Heading text='Datenschutz bei Schnoffle?' level={6}/>
                <p>Die Informationen zum Datenschutz bei der Becker & Karsten UG
                    (haftungsbeschränkt), Sandhauser Straße
                    107, 13505 Berlin, <InternalLink
                        className='stolo-footer-link'
                        to={{ type: types.NAVIGATED_TO_PRIVACY }}
                    >
                        kannst Du hier lesen
                    </InternalLink></p>

                <Text.Heading text='Datenschutz Instagram' level={6}/>
                <p><a
                    href='https://help.instagram.com/519522125107875?helpref=page_content'
                >Instagram-Datenschutzrichtlinie</a>
                </p>

                <Text.Heading text='Datenschutz Facebook' level={6}/>
                <p><a href='https://de-de.facebook.com/policy.php'>Facebook
                    Datenrichtlinie</a></p>

                <Text.Heading text='Datenschutz Pinterest' level={6}/>
                <p><a href='https://policy.pinterest.com/de/privacy-policy'>Pinterest
                    Datenschutz</a></p>
            </CollapsableContainer>
            <History/>
        </Text>

    </React.Fragment>
);

export default Hashtag;



// WEBPACK FOOTER //
// ./src/components/hashtag/Hashtag.js